var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRemoveIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E51717",
  fillRule: "evenodd",
  d: "M3.417 10a6.582 6.582 0 1 1 13.165 0 6.582 6.582 0 0 1-13.165 0M10 2.418a7.582 7.582 0 1 0 0 15.165 7.582 7.582 0 0 0 0-15.165m3.334 8.082a.5.5 0 1 0 0-1H6.667a.5.5 0 1 0 0 1z",
  clipRule: "evenodd"
})));
export default SvgRemoveIcon;